import { DOCUMENT } from '@angular/common';
import { Component, Injector, OnInit, AfterViewInit, Inject } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { switchMap, tap, withLatestFrom } from 'rxjs/operators';
import { CtaSeoQuery, PageSeoQuery } from '@b2b-app/b2b-core';
import { CtaSeo, PageSeo } from '@conciliome/concilio-model';
import { ConcilioComponent } from '@conciliome/concilio-core';

@Component({
  selector: 'b2b-ui-page-seo',
  templateUrl: './page-seo.component.html',
  styleUrls: ['./page-seo.component.scss'],
})
export class PageSeoComponent extends ConcilioComponent implements OnInit, AfterViewInit {
  pageSeo: PageSeo;
  pageSeoId: string;
  ctaSeo: CtaSeo;

  constructor(
    injector: Injector,
    @Inject(DOCUMENT) private dom: Document,
    private pageSeoQuery: PageSeoQuery,
    private ctaSeoQuery: CtaSeoQuery,
    private meta: Meta,
    private titleService: Title
  ) {
    super(injector);

    this.addSubscription(
      this.route.params
        .pipe(
          tap((params) => {
            this.pageSeoId = params['id'];
          }),
          switchMap((params) => this.pageSeoQuery.allPages$),
          withLatestFrom(this.ctaSeoQuery.allCtas$)
        )
        .subscribe(([pages, ctas]) => {
          this.pageSeo = pages.find((page) => page.slug === this.pageSeoId);
          this.ctaSeo = ctas.find((cta) => cta.slug === 'cta-seo');
          this.updateCanonicalUrl();
          this.updateTags();
        })
    );
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }

  updateTags() {
    if (this.pageSeo) {
      this.titleService.setTitle(this.pageSeo.titre);
      this.meta.updateTag({ name: 'title', content: this.pageSeo.meta_title });
      this.meta.updateTag({ name: 'description', content: this.pageSeo.meta_description });
      this.meta.updateTag({ name: 'keywords', content: this.pageSeo.meta_keywords });
      this.meta.updateTag({ name: 'og:title', content: this.pageSeo.meta_title });
      this.meta.updateTag({ name: 'og:description', content: this.pageSeo.meta_description });
    }
  }

  updateCanonicalUrl() {
    const head = this.dom.getElementsByTagName('head')[0];
    let element: HTMLLinkElement = this.dom.querySelector(`link[rel='canonical']`) || null;
    if (element == null) {
      element = this.dom.createElement('link') as HTMLLinkElement;
      head.appendChild(element);
    }
    element.setAttribute('rel', 'canonical');
    element.setAttribute('href', `${location.origin}${location.pathname}`);
  }

  trackByFn(index: number, item: any) {
    return item.id;
  }
}
